var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "modal__content-title" }, [
      _c("span", { staticClass: "modal__wo-id h-color-fuel-blue" }, [
        _vm._v("FM" + _vm._s(_vm.item.work_order_id))
      ]),
      _vm._v(" "),
      _c("span", {
        staticClass: "modal__item-title",
        domProps: { innerHTML: _vm._s(_vm.item.title) }
      }),
      _vm._v(" "),
      _vm.item.details
        ? _c("div", {
            staticClass: "modal__item-details",
            domProps: { innerHTML: _vm._s(_vm.item.details) }
          })
        : _vm._e()
    ]),
    _vm._v(" "),
    _vm.item.objective
      ? _c("div", { staticClass: "modal__wo-objective h-italic-text" }, [
          _vm._v(_vm._s(_vm.item.objective))
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "grid modal__wo-meta-data" }, [
      _c(
        "div",
        { staticClass: "grid__col-no-gutter--4 h-no-padding" },
        [
          _c("People", { attrs: { item: _vm.item } }),
          _vm._v(" "),
          _c("FileAttachments", { attrs: { item: _vm.item } })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "grid__col-no-gutter--8 h-no-padding" }, [
        _c("div", { staticClass: "modal__info-pills" }, [
          _c("div", { staticClass: "modal__info-pill modal__wo-status" }, [
            _c("div", {
              staticClass: "modal__wo-status-dot",
              class: "modal__wo-status-dot--" + _vm.statusClass
            }),
            _vm._v("\n          " + _vm._s(_vm.statusTitle) + "\n        ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal__info-pill modal__wo-department" }, [
            _c("span", {
              staticClass: "glyphicon queue-detail__glyph",
              class: [
                _vm.departmentIcon,
                "queue-detail__glyph--" + _vm.item.department
              ],
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v("\n          " + _vm._s(_vm.departmentTitle) + "\n        ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal__info-pill modal__wo-specialty" }, [
            _vm._v(_vm._s(_vm.item.specialty))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal__info-pill modal__wo-created" }, [
            _c("span", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: { content: "Start Date: " + _vm.startDate },
                  expression: "{ content:`Start Date: ${startDate}` }"
                }
              ],
              staticClass:
                "glyphicon queue-detail__glyph glyphicon-calendar h-color-fuel-navy",
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v("\n          " + _vm._s(_vm.startDate) + "\n        ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal__info-pill modal__wo-time-spent" }, [
            _c("span", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: { content: "Time Spent" },
                  expression: "{ content: 'Time Spent' }"
                }
              ],
              staticClass:
                "glyphicon queue-detail__glyph glyphicon-time h-color-fuel-navy",
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v(
              "\n          " + _vm._s(_vm.item.timeSpent) + " min\n        "
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "modal__item-row" }, [
          _vm.item.note
            ? _c("div", { staticClass: "grid modal__wo-note-container" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", {
                  staticClass:
                    "grid__col--11 h-no-margin h-no-padding modal__wo-note",
                  domProps: { innerHTML: _vm._s(_vm.item.note) }
                })
              ])
            : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "grid__col--1 h-no-padding h-right-align" },
      [_c("i", { staticClass: "fas fa-sticky-note h-color-fuel-navy" })]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }